<template>
<v-expansion-panel-header>
    <span
    style="font-size: 1.2rem;"
    >
    <v-icon
        style="margin-right: 10px;"
        size="30"
        :color="icon_color"
    >
        {{icon}}
    </v-icon>
    <b
        style="position: relative; top: 3px;"
    >
        {{label}}
    </b>
    </span>
</v-expansion-panel-header>
</template>

<script>
export default {
    props: {

        label: {
            type: String,
            default: function() { return 'Title'; }
        },

        complete: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    computed: {
        icon() {
            if ( this.complete )
            {
                return 'mdi-check-circle-outline';
            }

            return 'mdi-circle-outline';
        },

        icon_color() {
            if ( this.complete )
                return 'green';
            
            return null;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>